module.exports = __webpack_public_path__ + "img/note.4074a78d.png";